import { render, staticRenderFns } from "./createComponent.vue?vue&type=template&id=0011ee0b&scoped=true"
import script from "./createComponent.vue?vue&type=script&lang=js"
export * from "./createComponent.vue?vue&type=script&lang=js"
import style0 from "./createComponent.vue?vue&type=style&index=0&id=0011ee0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0011ee0b",
  null
  
)

export default component.exports